import { render } from "./showcertification.vue?vue&type=template&id=04f09fb4&scoped=true"
import script from "./showcertification.vue?vue&type=script&lang=js"
export * from "./showcertification.vue?vue&type=script&lang=js"

import "./showcertification.vue?vue&type=style&index=0&id=04f09fb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f09fb4"]])

export default __exports__